'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates an RFC4122, version 4 compliant guid
 * http://byronsalau.com/blog/how-to-create-a-guid-uuid-in-javascript/
 * @returns {string}
 */
var createGuid = function createGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

exports.default = createGuid;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/GuidService.js
// module id = 814
// module chunks = 10